import { AbstractControl, ValidatorFn } from '@angular/forms';
import { AllowedDate } from 'src/app/client/repositories/lib/common/utils/allowed-date';
import { ValidatorMessageModel } from '../validator-message.model';

export class DateValidators {
  static invalidDate(control: AbstractControl): {
    [key: string]: ValidatorMessageModel;
  } | null {
    const error = {
      invalidDate: new ValidatorMessageModel('validators.date.enterValidDate'),
    };

    if (DateValidators.isEmpty(control.value)) {
      return null;
    }

    return DateValidators.isValidDate(control.value) ? null : error;
  }

  static maxDate(maxDate: Date): ValidatorFn {
    return (control: AbstractControl) => {
      const date = DateValidators.getComparableDate(control.value);
      if (date && date > DateValidators.getComparableDate(maxDate)!) {
        return {
          maxDate: new ValidatorMessageModel(
            'validators.date.maxDate',
            maxDate.toDateString()
          ),
        };
      }
      return null;
    };
  }

  static minDate(minDate: Date): ValidatorFn {
    return (control: AbstractControl) => {
      const date = DateValidators.getComparableDate(control.value);
      if (date && date < DateValidators.getComparableDate(minDate)!) {
        return {
          minDate: new ValidatorMessageModel(
            'validators.date.minDate',
            minDate.toDateString()
          ),
        };
      }
      return null;
    };
  }

  static allowedAge(control: AbstractControl): {
    [key: string]: ValidatorMessageModel;
  } | null {
    const date = DateValidators.getComparableDate(control.value);
    if (date && date > DateValidators.getComparableDate(AllowedDate.maxAllowedDate)!) {
      return {
        maxDate: new ValidatorMessageModel(
          'validators.date.allowedAge',
          AllowedDate.maxAllowedAge.toString()
        ),
      };
    }
    return null;
  }

  static maxDateSmokingBehavoiur(maxDate: Date): ValidatorFn {
    return (control: AbstractControl) => {
      if (control.value > maxDate) {
        return {
          maxLength: new ValidatorMessageModel(
            'validators.smokingBehaviour.notSmokedSince',
            maxDate.toDateString()
          ),
        };
      }
      return null;
    };
  }

  static getBirthDateValidators(): ValidatorFn[] {
    return [this.invalidDate, this.allowedAge];
  }

  static getStartOfContractValidators(date: Date): ValidatorFn[] {
    return [this.invalidDate, this.minDate(date)];
  }

  private static isValidDate(value: unknown): value is Date {
    return value instanceof Date && !Number.isNaN(value.getTime());
  }

  private static isEmpty(value: unknown): boolean {
    return value === null || value === undefined || value === '';
  }

  private static getComparableDate(value: unknown): Date | null {
    if (!DateValidators.isValidDate(value)) {
      return null;
    }

    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }
}
